﻿import type { CallbackType } from '../types/utils/validation';
import type { Iti } from 'intl-tel-input';

function checkValidationErrors(errors: any[], subclass?: string, showMessageCallback?: CallbackType): boolean {
    if (errors && Object.keys(errors).length) {
        for (const error in errors) {
            if (errors.hasOwnProperty(error)) {
                if (typeof (errors[error]) === 'object') {
                    checkValidationErrors(errors[error], error + '.');
                    continue;
                }

                showMessageCallback
                    ? showMessageCallback(errors, error)
                    : showMessage($(document), subclass ? subclass + error : error, [errors[error]]);
            }
        }
        setTimeout(() => $('.k-tooltip-validation').hide(), 3000);

        return false;
    }
    else {
        return true;
    }
}

function validateForecast(labelName: string) {
    // контролируем, чтобы пользователь мог вводить только цифры и символ ':'
    const sText1 = window.getTextFromComboBox(labelName);
    const str1 = sText1?.replace(/[^0-9:]+/g, '') ?? '';

    window.setTextToComboBox(labelName, str1);

    //обрезаем все что больше 6 символов
    while (window.getTextFromComboBox(labelName)!.length > 6) {
        const sText2 = window.getTextFromComboBox(labelName);
        const str2 = sText2?.slice(0, sText2?.length - 1) ?? '';
        window.setTextToComboBox(labelName, str2);
    }

    //контролируем, чтобы вводили только один символ ':' после 2 или 3 символа
    let i = 0;
    const searhChar = ':';
    let strRes = '';
    const str = window.getTextFromComboBox(labelName);
    if (!str) return;
    while (i < str.length) {
        if ((str[i] !== searhChar) || ((str[i] === searhChar && i === 2) || (i === 3 && str[i - 1] !== searhChar))) {
            strRes += str[i];
        }
        i++;
    }
    window.setTextToComboBox(labelName, strRes);

    // ищем : и проверяем, чтобы не ввели всякую ерунду после : может быть только максимум 59
    const str3 = window.getTextFromComboBox(labelName);
    if (!str3) return;
    const index = str3.indexOf(searhChar);

    if (index !== -1) {
        let j = 0;
        let strRes2 = '';

        while (j < str3.length) {
            if (((j <= index) || ((j === index + 1) && (parseInt(str3[j]) <= 5))) || ((j === index + 2) && (parseInt(str3[j - 1]) <= 5))) {
                strRes2 += str3[j];
            }
            j++;
        }
        window.setTextToComboBox(labelName, strRes2);
    }
}

function showMessage(container: JQuery<Document>, name: string, errors: any[]) {
    const messageSpan = container.find(`[data-valmsg-for="${name}"],[data-val-msg-for="${name}"]`);
    const prevElem = messageSpan.prev();
    const input = prevElem.find('input');
    /**
     * add style to input with the error
     * */
    prevElem.addClass('k-input-validation-error');

    const removeErrorClass = () => {
        prevElem.removeClass('k-input-validation-error');
        input.off('change', removeErrorClass);
    };
    input.on('change', removeErrorClass);

    /**
     * add validation message to the form
     * */
    messageSpan.replaceWith(window.validationMessageTmpl({
        field: name,
        message: errors[0]
    }));
}

function validatePhoneInput(iti: Iti) {
    $(this).kendoValidator({
        validationSummary: undefined,
        rules: {
            phoneValidation: () => {
                $('.field-validation-error').remove();
                if (!iti?.isValidNumber()) {
                    this.value = ' ';
                    return false;
                }
                return true;
            }
        },
        messages: {
            phoneValidation: 'Неверный телефон'
        }
    });
}

function validatePhoneTextBox(inputElement: JQuery<HTMLInputElement>, regexp: RegExp) {
    const parentElement = inputElement.closest('.k-textbox, .k-combobox');
    if (!parentElement.find('.k-input-validation-icon').length) {
        parentElement.append(`
            <span class='k-input-validation-icon k-icon k-i-warning k-hidden'></span>
        `);
    }

    const validationIcon = parentElement.find('.k-input-validation-icon');
    inputElement.on('input', ({ currentTarget }) => {
        const value = currentTarget.value;

        if (value) {
            currentTarget.value = value.replace(regexp, (match) => {
                const hasError = Boolean(match);
                parentElement.toggleClass('k-invalid', hasError);
                validationIcon.toggleClass('k-hidden', !hasError);
                return '';
            }).trim();

            /**
             * Анимированно удаляем иконку
             * */
            setTimeout(() => {
                parentElement.removeClass('k-invalid');
                validationIcon.addClass('k-hidden');
            }, 100);
        }
    });
}

window.validateForecast = validateForecast;
window.checkValidationErrors = checkValidationErrors;
window.validatePhoneInput = validatePhoneInput;
window.validatePhoneTextBox = validatePhoneTextBox;